
import ajax from './Ajax'

const applicationName = 'Project Contract Dashboard';

export default (e)=>{
  return ajax.post('applicationError',{applicationName,...e});
};



// WEBPACK FOOTER //
// ./src/utils/errorReport.js